import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sourceFile: null,
  convertedFile: null,
  converting: false,
  error: null
}

const documentConverterSlice = createSlice({
  name: 'documentConverter',
  initialState,
  reducers: {
    setSourceFile: (state, action) => {
      state.sourceFile = action.payload
    },
    setConvertedFile: (state, action) => {
      state.convertedFile = action.payload
    },
    setConverting: (state, action) => {
      state.converting = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    clearConverterState: (state) => {
      state.sourceFile = null
      state.convertedFile = null
      state.converting = false
      state.error = null
    }
  }
})

export const {
  setSourceFile,
  setConvertedFile,
  setConverting,
  setError,
  clearConverterState
} = documentConverterSlice.actions

export default documentConverterSlice.reducer
